import { useFrontendMaintenanceModeQuery } from '@shared/generated/graphql';

const DEFAULT_POLL_INTERVAL = 30 * 1000;

export function useFrontendMaintenanceMode(
  pollingInterval = DEFAULT_POLL_INTERVAL
) {
  const { data, loading, error } = useFrontendMaintenanceModeQuery({
    pollInterval: pollingInterval,
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
  });

  return {
    enabled: data?.frontendMaintenanceMode?.enabled ?? false,
    loading,
    error,
  };
}
